// @flow
import { changeCatalogPage, changeCatalogSearchTerms, getCatalogViewData } from '../../../redux/modules/viewData';
import { parseQueryParams, validateQueryParams } from '../../../utils/queryParams';
import type { DataLoaderParams } from '../../../types/DataLoaderParams';
import { fetchDataForCatalogPage } from '../../../redux/modules/catalogPage';
import { getIdFromPath } from '../../../utils/urls';
import { itemSortOrders } from '../../../enums';
import { recordAnalyticsForCatalogPageView } from '../../../redux/modules/analytics';

export default ({ location, store }: DataLoaderParams) => {
    const queryParams = parseQueryParams(location.search);
    const { pathname } = location;
    const { dispatch } = store;
    const catalogId = getIdFromPath(pathname);

    if (!catalogId) {
        return Promise.all([]);
    }
    const { page, terms } = validateQueryParams(queryParams, itemSortOrders);
    const state = store.getState();
    const viewData = getCatalogViewData(state, catalogId);
    const promises = [dispatch(fetchDataForCatalogPage(catalogId))];

    if (viewData.page !== page) {
        promises.push(dispatch(changeCatalogPage(catalogId, page)));
    }

    if (viewData.searchTerms !== terms) {
        promises.push(dispatch(changeCatalogSearchTerms(catalogId, terms)));
    }

    return Promise.all(promises).then(() => {
        return dispatch(recordAnalyticsForCatalogPageView(catalogId));
    });
};
